import React, { useMemo } from 'react';
import { Column, Row } from '@shared/ui/atoms/StructuralLayout';
import { CompanyTeamViewSidebar } from '@shared/ui/molecules/CompanyTeamViewSidebar';
import { WithCompanyViewSelector } from '@shared/hooks/WithCompanyViewSelector';
import Layout from '@shared/ui/organisms/layout/Layout';
import { HeadlineMedium } from '@shared/ui/atoms/fonts/Headline';
import { TagWithCount } from '@shared/models/tags.models';
import { TeamContentCard } from '@shared/ui/molecules/TeamContentCard';
import { CreateTagContentCard } from '@shared/ui/molecules/CreateTagContentCard';
import { TeamContentCardList } from "./ViewComponents";
import { useDispatch, useSelector } from "react-redux";
import {
  selectActiveOfficeId,
  selectCheckedWorkgroupIds,
  setCheckedWorkgroupIds
} from "../../../store/companyMovements.duck";
import { selectAllTags } from "@shared/store/userTags.duck";
import { useTranslation } from "react-i18next";
import { canUserEditGroups } from "@shared/utils/AccessControl";
import { DialogIdentifiers, openDialogWithPayload } from "@shared/store/dialog.duck";
import { selectCurrentUser } from "@shared/store/auth.duck";

export function CompanyTagsView() {
  const dispatch = useDispatch();
  WithCompanyViewSelector();
  const currentUser = useSelector(selectCurrentUser);
  const activeOfficeId = useSelector(selectActiveOfficeId);
  const tags = useSelector(selectAllTags);
  const {t} = useTranslation();
  const showEditIcon = canUserEditGroups(currentUser);
  const checkedWorkgroupIds = useSelector(selectCheckedWorkgroupIds);


  const visibleWorkgroups = useMemo(() => {
    if (activeOfficeId) {
      return tags.filter(t => t.officeIds && t.officeIds?.includes(activeOfficeId));
    } else {
      return tags;
    }
  }, [tags, activeOfficeId]);

  const onEditTagClick = (tag: TagWithCount) => {
    dispatch(openDialogWithPayload({
      payload: { tag: tag },
      activeDialog: DialogIdentifiers.CreateTagDialog,
    }));
  }

  const onWorkgroupCheckboxSelect = (tag: TagWithCount, state: boolean) => {
    if (state) {
      dispatch(setCheckedWorkgroupIds([...checkedWorkgroupIds, tag.id]));
    } else {
      dispatch(setCheckedWorkgroupIds(checkedWorkgroupIds.filter(id => id !== tag.id)));
    }
  }

  return (
    <Layout>
      <Row>
        <Column className="companyMovements__movements">
          <HeadlineMedium style={{marginBottom: 24}}>{t('company-view-page.work-groups')}</HeadlineMedium>

          <TeamContentCardList>
            {visibleWorkgroups.map((tag: TagWithCount, key: number) => (
              <TeamContentCard key={key}
                               label={tag.label}
                               link={`/whereabouts/company/tag/${tag.id}`}
                               showEditIcon={showEditIcon}
                               memberCount={tag.memberCount}
                               officeIds={tag.officeIds}
                               onEditClick={() => onEditTagClick(tag)}
                               checkboxEnabled={showEditIcon}
                               isChecked={checkedWorkgroupIds.includes(tag.id)}
                               onCheckboxChecked={(state: boolean) => onWorkgroupCheckboxSelect(tag, state)} />
            ))}
            <CreateTagContentCard label={'company-view-page.create-new-group'}
                                  buttonLabel={"button.create-new-group"}
                                  dialogToOpen={DialogIdentifiers.CreateTagDialog} />
          </TeamContentCardList>
        </Column>
        <CompanyTeamViewSidebar />
      </Row>
    </Layout>
  )
}
